import moment from "moment";
import React, { FC, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { orderRequestModel } from "../../../api/apiRequestObjects";
import apis from "../../../api/apis";
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import { notifyError } from "../../../config/toastNotification";
import "./OrderCount.styles.scss";

interface IProps {
  POSStatusKey: number;
  filteredDateValue: Date | null;
}

const OrderCount: FC<IProps> = ({ POSStatusKey, filteredDateValue }) => {
  const [count, setCount] = useState(0);
  const componentMounted = useRef(true);

  //get redux state
  const { user } = useSelector((state: any) => state.authentication);

  //fetch OrderCountByPOSStatusKey
  useEffect(() => {
    //const ac = new AbortController();
    const fetchData = async () => {
      try {
        orderRequestModel.UID.UserKey = user.UserKey;
        orderRequestModel.UID.LocationKey = user.LocationKey;
        orderRequestModel.UID.CompanyKey = user.CompanyKey;
        orderRequestModel.UID.EnvironmentName = user.EnvironmentName;

        orderRequestModel.POSStatusKey = POSStatusKey;
        orderRequestModel.OrderDate = filteredDateValue ?? moment();

        const response = await apis.Orders.fetchOrderCountByOrderStatus(
          orderRequestModel
        );

        if (response.ResponseType === APIResponseType.Success) {
          setCount(response.TotalRecordCount);
        } else {
          console.log("api fetching error");
        }
      } catch (e) {
        //notifyError();
        console.log(e);
      }
    };

    fetchData();

    //return () => ac.abort(); // Abort both fetches on unmount

    return () => {
      // This code runs when component is unmounted
      componentMounted.current = false;
    };
  }, [
    POSStatusKey,
    user.CompanyKey,
    user.EnvironmentName,
    user.LocationKey,
    user.UserKey,
    filteredDateValue,
  ]);

  return <div className="count-pill">{count > 99 ? "99+" : count}</div>;
};

export default OrderCount;
